<div class="googlePhoto-container">
  <a
    (click)="back()"
    href="javascript:void(0)"
    class="back-btn"

  >
    <img src="assets/images/arrow_back.svg"  alt="back" /> Back
  </a>
    <div class="photoUrl-container relative flex flex-col">
      <div class="selector-photo-heading flex justify-start items-center">
        <div class="selector-photo-header">
          <p *ngIf="true" class="relative">
            {{searchTerm}}&nbsp;
          </p>

          <span>({{ totalArts }} {{ totalArts > 1 ? 'artworks' : 'artwork' }}) </span>

          <div style="margin-left:auto;" [class.display-hidden]="!selectedArtList.length">
            <app-button (click)="clearSelection()" [useLowPadding]="true" [isDefault]="false" [text]="'Unselect All (' + selectedArtList.length + ')'" class="bg-transparent"></app-button>
          </div>
        </div>
      </div>
      <div [ngClass]="{'image-grid':images.length > 0,'noImageFound':images.length == 0}" #scrollContainer>

        <app-user-card *ngFor="let item of artList"
        [isSelectionEnabled]="role !== 'GUEST'"
        [userIsSelecting]="selectedArtList.length > 0"
        [selectOrder]="getSelectionOrder(item.id)"
        (onUserSelect)="toggleSelection(item)"
        (cardClick)="openArtDetails($event)"
        [card]="item"
        (openGuestLoginPopup)="openLoginModal()"
        >

        </app-user-card>
        <h2 *ngIf="!isLoading && images.length == 0">
          {{noDataFound}}
        </h2>
        <div #loadMoreTrigger class="loading-trigger"></div>
      </div>

      <div *ngIf="isDisable" class="selector-button flex justify-center items-center">
        <button
        [ngClass]="{ bgColor: role === 'GUEST' }"
        [disabled]="role !== 'GUEST'"
        (click)="isLoginPopupOpen = true"
        >
          Test on Frame
        </button>
        <button
        [ngClass]="{ bgColor: role === 'GUEST' || selectedArtList.length > 0 }"
        (click)="processSelectedImages()"
        [disabled]="selectedArtList.length === 0  && role !== 'GUEST'"
      >
        Subscribe
      </button>
      </div>
    </div>
  </div>


  <app-make-payment-multi-images
  (close)="isPayment = false"
  [art]="selectedArtIDs"
  [arts]="selectedArtList"
  *ngIf="isPayment"
></app-make-payment-multi-images>

<app-art-detail-card *ngIf="isArtDetailsOpen"
[card]="artistDetail"
(close)="onClickCloseArt()"
(openGuestLoginPopup)="openLoginModal()"
></app-art-detail-card>



<app-guest-login *ngIf="isLoginPopupOpen"
(close)="isLoginPopupOpen = false">
</app-guest-login>
